import { cn } from '@bem-react/classname';

export const cnCard = cn('Card');
export const cardHeaderTitleCn = cnCard('HeaderTitle');
export const cardHeaderLinkWrapCn = cnCard('HeaderLinkWrap');
export const cardSpinCn = cnCard('Spin');
